export function transformImportedTasks(
    initTasksList,
    projectId = 'ImportedProject',
    projectName = 'Obecny projekt'
) {
    if (!Array.isArray(initTasksList)) return []

    function parseDate(dateStr) {
        if (!dateStr) return null
        const d = new Date(dateStr)
        if (!isNaN(d.getTime())) return d
        const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})$/)
        if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
        return null
    }

    let totalStageBudget = 0;

    const tasks = initTasksList.map((item, idx) => {
        let start = parseDate(item.data_rozpoczecia) || new Date()
        let end = parseDate(item.data_zakonczenia) || start

        const isMilestone = item.czy_kamien_milowy === 'Tak';
        if (isMilestone) {
            start = parseDate(item.data_zakonczenia);
            end = start;
        }

        const taskBudget = parseFloat(item.budzet_planowany) || 0;
        totalStageBudget += taskBudget;

        const originalName = item.nazwa || `Imported task ${idx}`;

        return {
            start,
            end,
            name: '',
            originalName: originalName,
            id: `${projectId}_task_${idx}`,
            type: isMilestone ? 'milestone' : 'task',
            project: projectId,
            budget: taskBudget,
            is_milestone: isMilestone,
            _source: { ...item },
        }
    })

    const valid = tasks.filter(
        (t) => t.start instanceof Date && !isNaN(t.start.getTime())
    )
    const now = new Date()
    let pStart = valid.length ? valid[0].start : now
    let pEnd = valid.length ? valid[0].end : now
    for (let i = 0; i < valid.length; i++) {
        const t = valid[i]
        if (t.start && t.start.getTime() < pStart.getTime()) pStart = t.start
        if (t.end && t.end.getTime() > pEnd.getTime()) pEnd = t.end
    }

    const project = {
        start: pStart,
        end: pEnd,
        name: '',
        originalName: projectName,
        id: projectId,
        type: 'project',
        hideChildren: false,
        budget: totalStageBudget,
    }

    return [project, ...tasks]
}

export function getStartEndDateForProject(tasks, projectId) {
    const projectTasks = tasks.filter((t) => t.project === projectId)
    if (projectTasks.length === 0) return [new Date(), new Date()];
    let start = projectTasks[0].start
    let end = projectTasks[0].end
    for (let i = 0; i < projectTasks.length; i++) {
        const task = projectTasks[i]
        if (start.getTime() > task.start.getTime()) {
            start = task.start
        }
        if (end.getTime() < task.end.getTime()) {
            end = task.end
        }
    }
    return [start, end]
}

export function transformMultipleProjects(projectsData) {
    if (!Array.isArray(projectsData) || projectsData.length === 0) return []

    const allTasks = []

    projectsData.forEach((projectData) => {
        const { tasks: taskList, projectId, projectName } = projectData

        if (!Array.isArray(taskList) || taskList.length === 0) return

        const transformedTasks = transformImportedTasks(
            taskList,
            projectId,
            projectName
        )
        allTasks.push(...transformedTasks)
    })

    return allTasks
}

void transformImportedTasks